const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

const months = [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December',
]

export default ({ min, max }, start, end) => ({
    min: min ? new Date(new Date(min).setHours(0, 0, 0, 0)) : null,
    max: max ? new Date(new Date(max).setHours(0, 0, 0, 0)) : null,
    start: start ? new Date(new Date(start).setHours(0, 0, 0, 0)) : null,
    end: end ? new Date(new Date(end).setHours(0, 0, 0, 0)) : null,
    date: new Date(
        new Date(start || min || new Date().setHours(0, 0, 0, 0)).setDate(1)
    ),
    hoveredDate: null,

    init() {
        this.$watch('activeFilters.start', (value) => {
            this.start = value
                ? new Date(new Date(value).setHours(0, 0, 0, 0))
                : null
        })
        this.$watch('activeFilters.end', (value) => {
            this.end = value
                ? new Date(new Date(value).setHours(0, 0, 0, 0))
                : null
        })
    },

    get startValue() {
        if (!this.start) {
            return null
        }

        return formatDate(this.start)
    },

    get endValue() {
        if (!this.end) {
            return null
        }

        return formatDate(this.end)
    },

    get month() {
        return months[this.date.getMonth()]
    },

    get weeks() {
        const firstDayOfMonth = new Date(
            this.date.getFullYear(),
            this.date.getMonth(),
            1
        )
        const firstWeekDay =
            firstDayOfMonth.getDay() === 0 ? 7 : firstDayOfMonth.getDay() // Monday=1, Sunday=7
        const startOffset = 2 - firstWeekDay // ensures week starts with Monday
        const weeks = Array.from({ length: 6 }, (_, weekIndex) => {
            return Array.from({ length: 7 }, (_, dayIndex) => {
                const date = new Date(
                    this.date.getFullYear(),
                    this.date.getMonth(),
                    startOffset + weekIndex * 7 + dayIndex,
                    0,
                    0,
                    0,
                    0
                )

                return {
                    date,
                    isStart: this.isStart(date),
                    isEnd: this.isEnd(date),
                    isHighlighted: this.isHighlighted(date),
                    isSelectable: this.isSelectable(date),
                }
            })
        })

        return weeks
    },

    incrementMonth(delta) {
        let newDate = new Date(
            this.date.getFullYear(),
            this.date.getMonth() + delta,
            this.date.getDate()
        )

        if (this.min && newDate < this.min) {
            newDate = new Date(this.min)
        } else if (this.max && newDate > this.max) {
            newDate = new Date(this.max)
        }

        this.date = new Date(new Date(newDate).setDate(1))
    },

    selectDate(date) {
        if (!this.start || (this.start && this.end)) {
            this.start = date
            this.end = null
        } else if (this.start && !this.end) {
            if (date < this.start) {
                this.end = this.start
                this.start = date
            } else {
                this.end = date
            }
        }

        this.$el.dispatchEvent(
            new CustomEvent('changeDate', {
                bubbles: true,
                detail: {
                    start: this.startValue,
                    end: this.endValue,
                },
            })
        )
    },

    isStart(date) {
        return this.start && date.toDateString() === this.start.toDateString()
    },

    isEnd(date) {
        return this.end && date.toDateString() === this.end.toDateString()
    },

    isHighlighted(date) {
        const dates = [this.start, this.end]
            .filter(Boolean)
            .sort((a, b) => a - b)
        const min = dates.at(0)
        const max = dates.at(-1)

        return date >= min && date <= max
    },

    isSelectable(date) {
        if (this.min && date < this.min) {
            return false
        }

        if (this.max && date > this.max) {
            return false
        }

        return true
    },

    hasEvents(dates, date) {
        if (!dates || !date) {
            return false
        }

        const formatted = formatDate(date)
        const { count } = dates[formatted] || {}

        return !!count
    },
})
